let currentOrganizationId = null

const bytesToHex = (bytes) =>
  Array.from(bytes, (byte) => byte.toString(16).padStart(2, '0')).join('')

const getRandomBytes = (byteCount) => {
  const bytes = new Uint8Array(byteCount)

  if (globalThis.crypto?.getRandomValues) {
    globalThis.crypto.getRandomValues(bytes)
    return bytes
  }

  for (let index = 0; index < byteCount; index += 1) {
    bytes[index] = Math.floor(Math.random() * 256)
  }

  return bytes
}

const createNonZeroHex = (byteCount) => {
  let value = ''

  do {
    value = bytesToHex(getRandomBytes(byteCount))
  } while (/^0+$/.test(value))

  return value
}

export const createRequestId = () => {
  if (globalThis.crypto?.randomUUID) {
    return globalThis.crypto.randomUUID()
  }

  const bytes = getRandomBytes(16)
  bytes[6] = (bytes[6] & 0x0f) | 0x40
  bytes[8] = (bytes[8] & 0x3f) | 0x80
  const hex = bytesToHex(bytes)

  return [
    hex.slice(0, 8),
    hex.slice(8, 12),
    hex.slice(12, 16),
    hex.slice(16, 20),
    hex.slice(20),
  ].join('-')
}

export const createTraceparent = () =>
  `00-${createNonZeroHex(16)}-${createNonZeroHex(8)}-01`

export const setRequestOrganizationId = (organizationId) => {
  const normalizedOrganizationId = String(organizationId ?? '').trim()
  currentOrganizationId = normalizedOrganizationId || null
}

export const getRequestOrganizationId = () => currentOrganizationId

export const clearRequestOrganizationId = () => {
  currentOrganizationId = null
}
